import _get from 'lodash/get';
export const checklists = (state) => state.checklists.checklists;
export const firstLoad = (state) => state.checklists.firstLoad;
export const isChanged = (state) => state.checklists.isChanged;
export const uploadError = (state) => state.checklists.uploadError;
export const checklistProjectId = (state) => state.checklists.selectedProjectId;
export const isProjectOwner = (state) => {
    const isProjectLoaded = _get(state, 'project.details.id', false);

    if (isProjectLoaded) {

        let isProjectOwner = false;

        const project = _get(state, 'project.details', false);
        isProjectOwner = _get(project, 'owner.id') === state.auth.userId;

        if (!isProjectOwner) {
            const allowMembersToChangeChecklists = _get(project, 'allowMembersToChangeChecklists');

            if (allowMembersToChangeChecklists) {
                isProjectOwner = true;
            }
        }

        return isProjectOwner;

    }

    return true;
};
export const isLoaded = (state) => state.checklists.isLoaded;
